let citySelector = $('.gift-card-form__city > select');
let selectedCard;
let selectedAmount;
let selectedUnique;
let cartIcon = $(".header-icons__item_cart").children("div");
let cart = JSON.parse(localStorage.getItem("cart")) || [];

citySelector.change(function () {
    let selectedCity = citySelector.val();
    $('.calendar__preloader').addClass('show');
    $.ajax({
        url: themeVars.ajax_url,
        type: "POST",
        data: {
            action: "citySelector",
            data: selectedCity,
        }, success: function (response) {
            $('.calendar__preloader').removeClass('show');
            $('.gift-card-form__cards-list').html(response);
            $('.sel-ajax > select').niceSelect();
        },
    });

})
$(document).on('change', '.gift-card-form__amount > select', function () {
    selectedAmount = $(this).val();
    $('.gift-card-form__btn input').prop("disabled", false);
})

$(document).on('change', '.gift-card-form__variation > select', function () {
    selectedCard = $(this).val();
    selectedUnique = $(this).find(':selected').data('unique');

    $.ajax({
        url: themeVars.ajax_url,
        type: "POST",
        data: {
            action: "getProductCode",
            data: selectedCard,
        }, success: function (response) {
            let result = $.parseJSON(response);
            $('.gift-card-form__cards-list').data('productcode', result['productCode']);
            $('.gift-card-form__cards-list').data('productprice', result['cardPrice']);
            $('.gift-card-form__cards-list').data('productcurrency', result['priceCurrency']);
        },
    });
});
$(document).on('click', '.gift-card-form__btn input', function () {
    let bookButton = $('.gift-card-form__btn input');
    let quantity = selectedAmount;
    let postId = selectedCard;
    let currentCode = $('.gift-card-form__cards-list').data('productcode');
    let cardPrice = $('.gift-card-form__cards-list').data('productprice');
    let priceCurrency = $('.gift-card-form__cards-list').data('productcurrency');
    let tour = {
        tourId: postId,
        tourCode: currentCode,
        tourDate: selectedUnique,
        tourVariations: [
            {
                groupValue: 1,
                quantity: quantity,
                tourOptionId: selectedUnique,
                tourPrice: cardPrice * quantity,
                tourPriceCurrency: priceCurrency,
                tourPriceSingle: cardPrice,
            },
        ],
    };
    // successMessage = $(".filters-tour__success");
    // successMessage.show();
    bookButton.prop("disabled", true);

    const IsInCart =
        cart.filter(
            cartItem =>
                cartItem.tourCode === tour.tourCode &&
                cartItem.tourDate === tour.tourDate
        ).length > 0;

    if (IsInCart) {
        cart.map(function (cartItem) {
            if (
                cartItem.tourCode === tour.tourCode &&
                cartItem.tourDate === tour.tourDate
            ) {
                let newOptionVariation = tour.tourVariations[0];
                let existFlag = false;

                cartItem.tourVariations.map(option => {
                    if (option.tourOptionId === newOptionVariation.tourOptionId) {
                        option.quantity = parseInt(option.quantity) + parseInt(quantity);
                        option.tourPrice =
                            parseInt(option.tourPrice) +
                            parseInt(newOptionVariation.tourPrice);
                        existFlag = true;
                    }
                    return option;
                });

                if (!existFlag) {
                    cartItem.tourVariations.push(newOptionVariation);
                }
            }
            return cartItem;
        });
        localStorage.setItem("cart", JSON.stringify(cart));
    } else {
        cart.push(tour);
        localStorage.setItem("cart", JSON.stringify(cart));
    }
    if (cart.length == 1) {
        cartIcon.addClass("counter-icon").html(cart.length);
        $(".header-icons__item_cart").addClass('filled');
    } else {
        cartIcon.html(cart.length);
    }

})


// WEBPACK FOOTER //
// ./scripts/modules/gift-card.js